import { StripeUser } from "@builder/types/Users.type";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";

export const stripeApi = createApi({
    reducerPath: "stripeApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${import.meta.env.VITE_URL_HUB_API}hub-stripe`,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["stripe"],
    endpoints: builder => ({
        createStripeCustomer: builder.mutation<
            StripeUser,
            { companyId: string; companyName: string; name: string; email: string; organizationCategory: string; referralSource: string }
        >({
            query: ({ companyId, companyName, name, email, organizationCategory, referralSource }) => ({
                url: `/create-customer`,
                method: "POST",
                body: { companyId, companyName, name, email, organizationCategory, referralSource }
            })
        })
    })
});

export const { useCreateStripeCustomerMutation } = stripeApi;
